import axios from "axios";
import { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import PaymentList from "../../../components/PaymentList";
import { API_URL } from "../../../url/api";
import { getHumanReadableDate, getHumanReadableTime } from "../../../utils";
import AvailabilitySettings from "../../AvailabilitySettings";
import DcotorAccount from "../../DoctorAccount";
import AssessmentReportUpload from "../AssessmentReportUpload";
import AppointmentTable from "../Components/AppointmentTable";
import DoctorDashboardSideBar from "../Components/DoctorSideBar";
import SessionDetails from "../SessionDetails";
interface Therapist {
  id: number;
  name: string;
  email: string;
  phone: string;
  age: string;
  image: string;
  specialty: string;
  experience: number;
  licensure: string;
  message: string;
  is_email_send: boolean;
  created_at: string;
}

interface User {
  id: number;
  name: string;
  email: string;
}

interface ScheduleTime {
  id: number;
  date: string;
}

interface TimeSlot {
  id: number;
  datetime: string;
}

interface Appointment {
  id: number;
  user: User;
  schedule_time: ScheduleTime;
  time_slot: TimeSlot;
  is_paid: boolean;
}

interface ApiData {
  id: number;
  therapist: Therapist;
  appointment: Appointment[];
}

const DashboardDoctor = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [apiData, setApiData] = useState<ApiData | null>(null);

  const [openSessionPopup, setOpenSessionPopup] = useState(false);
  const [selectedSession, setSelectedSession] = useState(0);

  const [statsData, setStatsData] = useState({
    upcoming_sessions: 0,
    completed_sessions: 0,
    available_slots: 0,
  });

  const [doctorID, setDoctorID] = useState<string | null>(null);

  useEffect(() => {
    const doctorIdfromLocal = localStorage.getItem("doctorId");
    console.log("Doctor ID from local storage:", doctorIdfromLocal);
    if (doctorIdfromLocal) {
      setDoctorID(doctorIdfromLocal);
      fetchStatsData(doctorIdfromLocal);
      fetchData(doctorIdfromLocal);
    } else {
      console.log("Doctor ID not found in local storage");
      window.location.href = "/therapist/signin";
    }
  }, []);

  const fetchStatsData = async (doctor: string) => {
    try {
      const response = await axios.get(
        `${API_URL}v2/doctors/${doctor}/summary/`
      );
      setStatsData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchData = async (doctor: string) => {
    try {
      const response = await axios.get(
        `${API_URL}v2/doctors/${doctor}/upcoming-appointments/`
      );
      setApiData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const upcomingAppointments =
    apiData?.appointment?.map((appointment) => ({
      id: appointment.id,
      patientName: appointment.user.name,
      date: appointment.time_slot.datetime,
      // time: appointment.time_slot.time,
    })) || [];

  // const filteredAppointments = upcomingAppointments.filter((appointment) => {
  //   const appointmentTime = new Date(
  //     appointment.date + "T" + appointment.time
  //   ).getTime();
  //   const currentTime = new Date().getTime();
  //   const differenceInHours =
  //     (currentTime - appointmentTime) / (1000 * 60 * 60);
  //   console.log(
  //     "🚀 ~ .filter ~ differenceInHours:",
  //     new Date(appointment.date + "T" + appointment.time).toLocaleTimeString(
  //       "en-US",
  //       {
  //         hour12: true,
  //       }
  //     ),differenceInHours,
  //     differenceInHours <= 1
  //   );
  //   return differenceInHours <= 1;
  // });

  const handleTabClick = (tab: string) => setActiveTab(tab);

  return (
    <div className="flex flex-col items-center justify-center bg-gray-100 w-full">
      <div className="flex flex-col md:flex-row w-full h-screen overflow-hidden">
        <div className="w-1/6 bg-grey-100">
          <DoctorDashboardSideBar
            handleTabClick={handleTabClick}
            activeTab={activeTab}
          />
        </div>
        <div className="w-full bg-gray-100 overflow-auto">
          <div className="px-4">
            <main className="max-w-7xl  mx-auto py-6 sm:px-6 lg:px-8">
              {/* Tabs */}

              {/* Tab Content */}
              <div className="mt-0">
                {activeTab === "dashboard" && (
                  <div>
                    {/* Stats */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                      <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">
                              Upcoming Sessions
                            </dt>
                            <dd className="mt-1 text-3xl font-semibold text-gray-900">
                              {statsData.upcoming_sessions}
                            </dd>
                          </dl>
                        </div>
                      </div>

                      <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">
                              Completed Sessions
                            </dt>
                            <dd className="mt-1 text-3xl font-semibold text-gray-900">
                              {statsData.completed_sessions}
                            </dd>
                          </dl>
                        </div>
                      </div>

                      <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">
                              Available Sessions
                            </dt>
                            <dd className="mt-1 text-3xl font-semibold text-gray-900">
                              {statsData.available_slots || 0}
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>

                    {/* Upcoming Appointments */}
                    <div className="bg-white overflow-hidden shadow rounded-lg">
                      <div className="px-4 py-5 sm:p-6">
                        <h2 className="text-lg font-medium text-gray-900 mb-4">
                          Upcoming Appointments
                        </h2>
                        {apiData ? (
                          <ul className="divide-y divide-gray-200">
                            {upcomingAppointments.map((appointment) => {
                              console.log(appointment.date);

                              return (
                                <li
                                  key={appointment.id}
                                  className="py-4 border px-6 rounded-md shadow-md mb-4"
                                >
                                  <div className="flex items-center justify-between">
                                    <div className="flex flex-col ">
                                      <p className="text-xl font-medium text-gray-900 capitalize">
                                        {appointment.patientName}
                                      </p>
                                      <p className="text-md text-gray-500">
                                        {getHumanReadableDate(appointment.date)}{" "}
                                        at{" "}
                                        {getHumanReadableTime(appointment.date)}
                                      </p>
                                    </div>

                                    <button
                                      onClick={() => {
                                        // Redirect to appointment details page
                                        console.log("View details clicked");
                                        setOpenSessionPopup(true);
                                        setSelectedSession(appointment.id);
                                      }}
                                      className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                    >
                                      View Details
                                    </button>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <p>Loading upcoming appointments...</p>
                        )}
                      </div>
                    </div>

                    {doctorID && <AppointmentTable doctorID={doctorID} />}
                  </div>
                )}

                {activeTab === "profile" && (
                  <DcotorAccount />
                  // <div>
                  //   {/* Profile content */}
                  //   <div className="flex justify-between items-center ">
                  //     <h2 className="text-2xl font-semibold text-gray-900">
                  //       Account settings{" "}
                  //     </h2>
                  //     <button
                  //       className="bg-blue-500 text-white px-4 py-2 rounded-lg mt-4"
                  //       onClick={() => (window.location.href = "/logout")}
                  //     >
                  //       <div className="flex flex-row justify-center items-center space-x-2">
                  //         <p>Logout</p>
                  //       </div>
                  //     </button>
                  //   </div>
                  //   {/* Add profile content here */}
                  // </div>
                )}

                {activeTab === "availability" && doctorID && (
                  <div>
                    {/* Availability content */}
                    {/* Add availability content here */}
                    <AvailabilitySettings doctorID={doctorID} />
                  </div>
                )}

                {activeTab === "assessment" && (
                  <AssessmentReportUpload doctorID={doctorID} />
                )}

                {activeTab === "billing" && (
                  <div>
                    {/* Billing content */}
                    <PaymentList />
                    {/* Add billing content here */}
                  </div>
                )}
              </div>
            </main>

            {openSessionPopup && (
              <div className="fixed w-full inset-0 flex flex-wrap items-center justify-center z-50 bg-black/30 backdrop-blur-sm">
                <div className="bg-white rounded-lg p-8 w-full md:w-2/3 overflow-auto h-full lg:h-auto">
                  <div className="flex justify-between items-center">
                    <h2 className="text-lg font-semibold text-gray-900">
                      Appointment Details
                    </h2>
                    <IoMdCloseCircle
                      onClick={() => setOpenSessionPopup(false)}
                      size={24}
                      className="cursor-pointer"
                    />
                  </div>
                  {/* Add appointment details content here */}
                  <SessionDetails sessionId={selectedSession} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardDoctor;
